export const KEY = '@purposity/devtools' as const
